<style src="./RspHistoryItem.scss" lang="scss"></style>
<template>
  <section class="rsp-history-item">
    <section class="item-description">
      <div class="id">
        <span class="badge lot" v-if="!!info.itemInfo.lot"
          >LOTE {{ info.itemInfo.lot }}</span
        >
        <span class="badge number">ITEM {{ info.itemInfo.number }}</span>
      </div>

      <div class="description-container">
        <span>
          {{ info.itemInfo.description }}
        </span>
      </div>

      <div class="iteminfo">
        <span class="number quantity"
          ><small>QT:</small>
          <strong>{{ info.itemInfo.quantity | DecimalNumber }}</strong></span
        >
        <span class="number factor"
          ><small>x</small
          ><strong>{{ info.itemInfo.factor | DecimalNumber }}</strong></span
        >
        <span class="number estimated"
          ><small>ESTIMADO: R$</small>
          <strong>{{
            info.itemInfo.estimated | CurrencyBR("Não Informado")
          }}</strong></span
        >
      </div>
    </section>

    <div v-if="isLoading" class="loadinglist">
      Loading...
    </div>
    <ul v-if="!isLoading" class="list">
      <li
        v-for="(item, itemIdx) in listItems"
        :key="itemIdx"
        @click="chooseItem(item)"
        class="item"
      >
        <div class="column1">
          <div class="client">
            <span class="client" :title="item.event.client">{{
              item.event.client
            }}</span>
          </div>

          <div class="eventinfo">
            <span class="info code" title="Codigo Alternativo">{{
              item.event.alternativeCode
            }}</span>
            <span class="info date" title="Data do evento">{{
              item.event.date | DateBR
            }}</span>
            <span
              class="info identification"
              :title="item.event.identification"
              >{{ item.event.identification }}</span
            >
          </div>

          <div class="iteminfo">
            <div class="identification">
              <span class="info codprod" title="Código do produto">{{
                item.quoted.codProd
              }}</span>
              <span class="info comercialname" title="Nome comercial">{{
                item.quoted.comercialName
              }}</span>
            </div>

            <!-- <span class="pativo" title="Princícpio Ativo">{{ item.quoted.pativo }}</span> -->

            <div class="bottominfo">
              <span
                v-if="item.quoted && item.quoted.isPriceGuaranted"
                class="guarantee"
              >
                <icon-star class="icon" />
                Garantia
              </span>
              <span class="lab" title="Laboratório">{{ item.quoted.lab }}</span>
              <span
                class="eventquantity"
                title="Quantidade pedido no edital do evento"
                ><small>Qt. Evt:</small>
                {{ item.quoted.quantity | DecimalNumber(null, null, 0) }}</span
              >
              <span
                class="stockquantity"
                title="Quantidade em estoque atualmente"
                ><small>Qt. Estq:</small>
                {{
                  item.quoted.stockQuantity | DecimalNumber(null, null, 0)
                }}</span
              >
            </div>
          </div>
        </div>

        <div class="column2">
          <div class="fieldset">
            <span class="title">Vlr. Custo Base</span>
            <span class="value" title="Valor Unitário"
              ><small>R$</small>
              {{ item.quoted.cost | CurrencyBR("N/D", 4) }}</span
            >
            <span class="totalvalue" title="Valor Total"
              ><small>R$</small>
              {{
                (item.quoted.cost * item.quoted.quantity) | CurrencyBR("N/D", 2)
              }}</span
            >
          </div>
          <div class="fieldset">
            <span class="title">Vlr. Mínimo</span>
            <span class="value" title="Valor Unitário"
              ><small>R$</small>
              {{ item.quoted.minimumPrice | CurrencyBR("N/D", 4) }}</span
            >
            <span class="totalvalue" title="Valor Total"
              ><small>R$</small>
              {{
                (item.quoted.minimumPrice * item.quoted.quantity)
                  | CurrencyBR("N/D", 2)
              }}</span
            >
          </div>
          <!-- <div class="fieldset">
            <span class="title">Vlr. Proposta</span>
            <span class="value"><small>R$</small> {{ item.quoted.proposalPrice | CurrencyBR('N/D', 4) }}</span>
          </div> -->
          <div class="fieldset">
            <span class="title">Data da Cotação</span>
            <span class="value">{{ item.quoted.updateDate | DateBR }}</span>
          </div>
        </div>

        <div class="column3">
          <template v-if="!item.ranking.winner.distributor">
            <div class="noranking">
              Sem Ranking
            </div>
          </template>
          <template v-if="!!item.ranking.winner.distributor">
            <div class="ranking winner">
              <div class="position">1º</div>
              <div class="info">
                <span class="distributor">{{
                  item.ranking.winner.distributor
                }}</span>
                <span class="lab">{{ item.ranking.winner.lab }}</span>
              </div>
              <div class="value">
                <span class="offer"
                  ><small>R$</small>
                  {{ item.ranking.winner.price | CurrencyBR(null, 4) }}</span
                >
                <span class="totaloffer"
                  ><small>R$</small>
                  {{
                    (item.ranking.winner.price * item.quoted.quantity)
                      | CurrencyBR(null, 2)
                  }}</span
                >
                <span
                  class="perc"
                  :class="{
                    perc__positive: item.ranking.winner.marckup >= 0,
                    perc__negative: item.ranking.winner.marckup < 0
                  }"
                >
                  <IconArrow
                    class="iconup"
                    v-if="item.ranking.winner.marckup >= 0"
                  />
                  <IconArrow
                    class="icondown"
                    v-if="item.ranking.winner.marckup < 0"
                  />{{ item.ranking.winner.marckup | DecimalNumber(0, 0, 0) }}
                  <small>%</small></span
                >
              </div>
            </div>

            <div class="ranking second">
              <div class="position">2º</div>
              <div class="info">
                <span class="distributor">{{
                  item.ranking.second.distributor
                }}</span>
                <span class="lab">{{ item.ranking.second.lab }}</span>
              </div>
              <div class="value">
                <span class="offer"
                  ><small>R$</small>
                  {{ item.ranking.second.price | CurrencyBR(null, 4) }}</span
                >
                <span class="totaloffer"
                  ><small>R$</small>
                  {{
                    (item.ranking.second.price * item.quoted.quantity)
                      | CurrencyBR(null, 2)
                  }}</span
                >
                <span
                  class="perc"
                  :class="{
                    perc__positive: item.ranking.second.marckup >= 0,
                    perc__negative: item.ranking.second.marckup < 0
                  }"
                >
                  <IconArrow
                    class="iconup"
                    v-if="item.ranking.second.marckup >= 0"
                  />
                  <IconArrow
                    class="icondown"
                    v-if="item.ranking.second.marckup < 0"
                  />{{ item.ranking.second.marckup | DecimalNumber(0, 0, 0) }}
                  <small>%</small></span
                >
              </div>
            </div>

            <div class="ranking third">
              <div class="position">3º</div>
              <div class="info">
                <span class="distributor">{{
                  item.ranking.third.distributor
                }}</span>
                <span class="lab">{{ item.ranking.third.lab }}</span>
              </div>
              <div class="value">
                <span class="offer"
                  ><small>R$</small>
                  {{ item.ranking.third.price | CurrencyBR(null, 4) }}</span
                >
                <span class="totaloffer"
                  ><small>R$</small>
                  {{
                    (item.ranking.third.price * item.quoted.quantity)
                      | CurrencyBR(null, 2)
                  }}</span
                >
                <span
                  class="perc"
                  :class="{
                    perc__positive: item.ranking.third.marckup >= 0,
                    perc__negative: item.ranking.third.marckup < 0
                  }"
                >
                  <IconArrow
                    class="iconup"
                    v-if="item.ranking.third.marckup >= 0"
                  />
                  <IconArrow
                    class="icondown"
                    v-if="item.ranking.third.marckup < 0"
                  />{{ item.ranking.third.marckup | DecimalNumber(0, 0, 0) }}
                  <small>%</small></span
                >
              </div>
            </div>
          </template>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { IconStar, IconArrow } from "@/components/primitives/icons";
import {
  CurrencyBR,
  DateBR,
  DecimalNumber
} from "@/components/primitives/helpers/filters";
import PreparePayloadToSelect from "../../helpers/PreparePayloadToSelect";

export default {
  name: "RspHistoryItem",
  components: {
    IconStar,
    IconArrow
  },
  props: {
    info: {
      default: () => ({})
    }
  },
  data: () => ({
    isLoading: false,
    listItems: []
  }),
  filters: {
    CurrencyBR,
    DateBR,
    DecimalNumber
  },
  mounted() {
    this.loadItemHistory();
  },
  methods: {
    async chooseItem(pItem) {
      const itemId = this.info.itemId;
      const stockId = pItem.quoted.itemId;
      const price = pItem.quoted.cost;
      await this.$store.dispatch("ItemPricing/ASSOCIATE_ITEM", {
        stockId,
        itemId,
        price
      });
      const eventId = this.$route.params.id;
      if (!eventId) return false;
      await this.$store.dispatch("ItemPricing/LIST_ALL_ITEMS", { eventId });

      // eslint-disable-next-line
      const { associated } = this.$store.getters[
        "ItemPricing/GET_ITEM_BY_QUOTE_ID"
      ](this.info.itemId);

      const proposalMargin = this.$store.getters["ItemPricing/PROPOSAL_MARGIN"];
      // eslint-disable-next-line
      const decimalPrecision = this.$store.getters[
        "ItemPricing/DECIMAL_PRECISION"
      ];

      associated.price = price;
      const quotationPayload = PreparePayloadToSelect({
        finalQuotePrice: price,
        item: associated,
        info: this.info,
        proposalMargin,
        decimalPrecision
      });
      await this.saveChoice(quotationPayload);
      this.$emit("finish-edition");
    },
    isChoosedAssociatedItem() {
      const quotedPrice = this.info.quoted.price;
      const quotedItemId = this.info.quoted.itemId;

      const associatedPrice = this.info.associated.price;
      const associatedItemId = this.info.associated.itemId;

      if (
        quotedPrice === associatedPrice &&
        quotedItemId === associatedItemId
      ) {
        return true;
      }

      return false;
    },
    async saveChoice(quotationPayload) {
      try {
        const payload = {
          quote: quotationPayload.item,
          ...quotationPayload
        };
        const info = await this.$store.dispatch(
          "ItemPricing/SELECT_QUOTE_ITEM",
          payload
        );
        this.$store.commit("ItemPricing/SET_ITEM", {
          itemId: this.info.itemId,
          info
        });

        this.$toasted.success("Item reassociado com sucesso");
        return true;
      } catch (error) {
        this.$toasted.error("Não foi possível salvar");
        return false;
      }
    },
    async loadItemHistory() {
      this.isLoading = true;

      try {
        const { eventItems } = await this.$store.dispatch("Stock/ITEM_HISTORY", {
          pativo: this.info.associated.pativo,
          factor: this.info.itemInfo.factor
        });

        this.listItems = eventItems.map(i => ({
          ...i,
          ranking: {
            winner: {
              ...i.ranking.winner,
              marckup: this.profitPerc({
                cost: i.quoted.cost,
                sale: i.ranking.winner.price
              })
            },
            second: {
              ...i.ranking.second,
              marckup: this.profitPerc({
                cost: i.quoted.cost,
                sale: i.ranking.second.price
              })
            },
            third: {
              ...i.ranking.third,
              marckup: this.profitPerc({
                cost: i.quoted.cost,
                sale: i.ranking.third.price
              })
            }
          }
        }));
      } catch (error) {
        return Error(error);
      } finally {
        this.isLoading = false;
      }
    },
    profitPerc({ cost, sale }) {
      return (sale * 100) / cost - 100;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/rsp-history-item/RspHistoryItem.vue